const planType = {
  MA: { text: 'MA', value: 'MA' },
  COM: { text: 'Commercial', value: 'COM' },
  MCAID: { text: 'MCAID', value: 'MCAID' },
};

export default planType;
